import React, { useContext, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import Loading from "../../Loading";
import { Spinner } from "react-bootstrap";

function UploadBatch() {
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [complete, setComplete] = React.useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [batchId, setBatchId] = React.useState(null);
    const [country, setCountry] = React.useState('');
    const { token, email } = useAuth();

    function getISOSystemDate() {
        const now = new Date();
        const offset = now.getTimezoneOffset();
        // A positive offset means the current time is behind UTC, so we subtract the offset
        // A negative offset means the current time is ahead of UTC, so subtracting a negative offset is equivalent to adding it
        const adjustedDate = new Date(now.getTime() - offset * 60 * 1000);
        const isoString = adjustedDate.toISOString();
        const timeZoneOffset = `${offset > 0 ? "-" : "+"}${String(Math.abs(offset / 60)).padStart(2,"0")}:00`;
        return `${isoString.slice(0, 23)}${timeZoneOffset}`;
    }
    const onSubmit = (event) => {

        event.preventDefault();
        if (selectedFile) {
            setLoading(true);
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('userId', email);
            formData.append('country', country); // Replace with actual country if needed
      
            // Send the file to your server using fetch or another method
            fetch('/api/batch/upload', {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
            },
              body: formData,
              credentials: 'include',
            })
            .then(response => response.json())
            .then(async data => {
                setLoading(false);
              // Handle the response from the server
                if (data.Submission_Id) {
                    setBatchId(data.Submission_Id); // Assuming the server returns the batch ID in the response
                    setComplete(true);
                    await fetch(`/api/user/batchUpload`, {
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            submissionId: data.Submission_Id,
                            userEmail: email,
                            fileName: selectedFile.name,
                            uploadDate: getISOSystemDate(),
                            status: 'Processing',
                            batchType: 'CDL' // Replace with actual batch type if needed
                        }),
                    })
                } else {
                    setError(true);
                }
            })
            .catch(error => {
              // Handle any errors
              console.error(error);
              setLoading(false);
              setError(true);
            });
        
    }
}
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

     return(
            <div className='Index'>
                    <div id='table' style={{width: '50%'}}>
                        <div id="banner-search">
                            <h4>Upload Batch File</h4>
                        </div>
                        <div className="alert alert-info mb-4" style={{ fontSize: "0.95em" }}>
                            <h6 className="alert-heading fw-bold">File Formatting Requirements:</h6>
                            <ul className="mb-0" style={{ paddingLeft: "20px" }}>
                                <li>Only <strong>.txt</strong> files are accepted.</li>
                                <li>All data must be structured as <strong>comma-separated</strong> entries.</li>
                                <li className="mt-2">
                                    <strong>US & Mexico:</strong> Requires 2 fields (Jurisdiction, License Number). <br/>
                                    <em>Example: <code>AL,H01234567</code> or <code>MX,DF012345</code></em>
                                </li>
                                <li className="mt-1">
                                    <strong>Canada:</strong> Requires 5 fields (Jurisdiction, License Number, Last Name, First Name, DOB). First name is optional and can be left blank.
                                    <ul className="mt-1 mb-0" style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                                        <li>
                                            <em>With First Name:</em> <code>AB,Z456789,DOE,JOHN,1959-07-09</code>
                                        </li>
                                        <li className="mt-1">
                                            <em>Without First Name:</em> <code>NL,Z876543,SMITH,,1970-07-27</code> <strong>(note the double comma where the name would be)</strong>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <form id="Index-form" onSubmit={onSubmit}>
                            <label style={{paddingBottom:"10px"}}>
                                <b>Select Country</b>
                                <br />
                                <select
                                    className="form-select mb-3"
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                    required
                                >
                                    <option selected value="" disabled>Select Country</option>
                                    <option value="US">United States</option>
                                    <option value="CA">Canada</option>
                                    <option value="MX">Mexico</option>
                                </select>
                            </label>
                            <br />
                            <div class="col-md-6">
                                <input class="form-control" type="file" id="formFile" accept=".txt" onChange={handleFileChange} />
                            </div>
                            <h6>Please select batch type</h6>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked />
                                <label class="form-check-label" for="flexRadioDefault2">
                                    CDL Batch
                                </label>
                            </div>
                            <br />
                            <button type="submit" className="btn btn-primary" id="button">Upload</button>
                            {loading && <div><Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner></div>}
                            {/* <button type="button" className="btn btn-primary" id="button" onClick={cancelSubmit}>Cancel</button> */}
                        </form>
                    </div>
                {complete && (
                    <div className="alert alert-success" style={{marginTop: "20px"}}>
                        <h5 style={{color: "green"}}>File uploaded successfully!</h5>
                    </div>
                )}
                {error && 
                    <div className="alert" style={{marginTop: "20px"}}>
                        <h5 style={{color: "red"}}>Issue with file upload</h5>
                    </div>
                }
            </div>
            
        )
}

export default UploadBatch;